import type { EstimateFeedback, FindingView } from '@backend/schemas'

export type FindingState = FindingView['state']
export type Column = NonNullable<FindingView['column']>
export type Responses = NonNullable<EstimateFeedback['responses']>

// Display order and labels of the CABAS Positioner columns
export const COLUMNS: { key: Column; label: string }[] = [
  { key: 'parts', label: 'Reservdelar' },
  { key: 'work', label: 'Arbetsoperationer' },
  { key: 'plastic', label: 'Plast' },
  { key: 'ytrikta', label: 'Ytrikta' },
  { key: 'maattrikta', label: 'Måttrikta' },
  { key: 'dm', label: 'D/M' },
  { key: 'paint', label: 'Lack' },
  { key: 'other', label: 'Övrigt' },
]

export const isOpenState = (state?: FindingState) => state === 'error' || state === 'warning' || state === 'question'

export const isOpen = (finding: FindingView) => finding.active && isOpenState(finding.state)

// OK findings aren't shown - except answered ones, so the answer can be undone
export const isShown = (finding: FindingView, responses: Responses) => isOpen(finding) || (finding.active && !!responses[finding.key])
